import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
    // Call the callback function when the component initializes
    this.handleCallback();
  }

  handleCallback(): void {
    // Handle the callback logic here
    // You can access any necessary data, query parameters, etc.
  }
}
